// src/components/DemoBanner.js
// Sempre visibile mentre si esplora la demo pubblica — non un vicolo cieco: un bottone porta
// dritto alla registrazione vera, saltando il login generico.
import React from "react";
import { useAuth } from "../contexts/AuthContext";

export default function DemoBanner() {
  const { logout } = useAuth();

  const registrati = async () => {
    sessionStorage.setItem("nexiora_apri_registrazione", "1");
    await logout();
  };

  return (
    <div style={{
      background: "linear-gradient(90deg,#1e1b4b,#7c3aed)", color: "#fff",
      padding: "8px 16px", display: "flex", alignItems: "center", justifyContent: "center",
      gap: 14, fontSize: 12.5, fontFamily: "'Inter',sans-serif", flexWrap: "wrap", flexShrink: 0,
    }}>
      <span>💜 Stai esplorando una demo di Nexiora — nulla di quello che vedi qui è modificabile.</span>
      <button onClick={registrati}
        style={{ padding: "5px 14px", borderRadius: 7, border: "1px solid rgba(255,255,255,.5)",
          background: "rgba(255,255,255,.15)", color: "#fff", fontSize: 12, fontWeight: 700,
          cursor: "pointer", fontFamily: "'Inter',sans-serif", whiteSpace: "nowrap" }}>
        Registra la tua azienda →
      </button>
    </div>
  );
}
